import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ElioHasPermissionModule } from '@elio/emanager-front/shared/directives';
import {
  AbstractFilterOption,
  AndFilterOption,
  OrFilterOption,
  SingleFilterOption,
  isAndFilterOption,
  isOrFilterOption,
  isSingleFilterOption,
} from '@elio/emanager-front/shared/models';
import { TranslocoModule } from '@ngneat/transloco';
import { FilterableType } from '../../filter.token';
import { ElioFilterAccordionComponent } from '../filter-accordion/filter-accordion.component';
import { ElioFiltersListComponent } from '../filters-list/filters-list.component';
import { ElioSingleFilterComponent } from '../single-filter/single-filter.component';

@Component({
  selector: 'elio-filter-item[filter]',
  templateUrl: './filter-item.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ElioFilterAccordionComponent,
    ElioFiltersListComponent,
    ElioHasPermissionModule,
    ElioSingleFilterComponent,
    TranslocoModule,
  ],
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioFilterItemComponent<T extends FilterableType> {
  @Input() set filter(filter: AbstractFilterOption<T>) {
    if (isSingleFilterOption(filter)) {
      this.singleFilter = filter;
    } else if (isAndFilterOption(filter)) {
      this.andFilter = filter;
    } else if (isOrFilterOption(filter)) {
      this.orFilter = filter;
    }
  }
  @Input() hasTranslation = true;

  singleFilter?: SingleFilterOption<T>;
  andFilter?: AndFilterOption<T>;
  orFilter?: OrFilterOption<T>;
}
